import { useState, useEffect, SetStateAction } from 'react';
import { LocalStorageKeys, LocalStorageValues } from 'src/types/common';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from 'src/utils/localStorage';

function useLocalStorageState<Key extends LocalStorageKeys>(
  key: Key,
  defaultValue: LocalStorageValues[Key]
) {
  const getInitialValue = (): LocalStorageValues[Key] => {
    const storedValue = getLocalStorageItem(key);
    return storedValue ? storedValue : defaultValue;
  };

  const [state, setState] = useState<LocalStorageValues[Key]>(getInitialValue);

  useEffect(() => {
    if (state !== null && state !== undefined) {
      setLocalStorageItem(key, state);
    } else {
      removeLocalStorageItem(key);
    }
  }, [key, state]);

  return [state, setState] as [
    LocalStorageValues[Key],
    React.Dispatch<SetStateAction<LocalStorageValues[Key]>>,
  ];
}

export default useLocalStorageState;
